/**
 * Emoji grid section component
 * Uses CSS content-visibility for browser-native virtualization
 */

import React from 'react';

const EmojiSection = React.memo(({ category, emojis, onSelect, currentValue }) => (
  <div className="ip-section">
    <div className="ip-section__header">{category}</div>
    <div className="ip-section__grid">
      {emojis.map((item, i) => (
        <button
          key={i}
          className={`ip-btn ${currentValue === item.emoji ? 'ip-btn--selected' : ''}`}
          onClick={() => onSelect({ type: 'emoji', value: item.emoji })}
        >
          {item.emoji}
        </button>
      ))}
    </div>
  </div>
));

EmojiSection.displayName = 'EmojiSection';

export default EmojiSection;

